/**
 * Checks if a session user is the owner of an anuncio by comparing
 * perfil_id, phone (with normalization), and email cross-matching.
 */

import { normalizePhone } from "@/lib/phone-utils";

interface SessionInfo {
  contato: string;
  perfil_id: string | null;
}

interface AnuncioInfo {
  anunciante_id?: string | null;
  id?: string;
}

export const checkIsOwner = (
  session: SessionInfo | null,
  anuncio: AnuncioInfo,
  ownedIds?: Set<string>,
): boolean => {
  if (!session) return false;

  // Match by perfil_id
  if (session.perfil_id && anuncio.anunciante_id && session.perfil_id === anuncio.anunciante_id) {
    return true;
  }

  // Match by backend-resolved owned IDs (covers phone/email cross-matching)
  if (ownedIds && anuncio.id && ownedIds.has(anuncio.id)) {
    return true;
  }

  return false;
};
